(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dsp-collection-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dsp-category-rail')) {
  customElements.define('dsp-category-rail', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.rail = this.querySelector('.dsp-category-grid__items');
      this.previous = this.querySelector('[data-rail-previous]');
      this.next = this.querySelector('[data-rail-next]');
      this.cards = [...this.rail.querySelectorAll('a')];
      this.filters = [...this.querySelectorAll('[data-category-filter]')];
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const update = () => {
        const cards = this.cards.filter(card => !card.hidden);
        const position = Math.abs(this.rail.scrollLeft);
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= maximum - 2;
        const bounds = this.rail.getBoundingClientRect();
        const visible = cards.filter(card => {
          const box = card.getBoundingClientRect();
          return box.right > bounds.left + box.width * .5 && box.left < bounds.right - box.width * .5;
        });
        const first = Math.max(1, cards.indexOf(visible[0]) + 1);
        const last = Math.max(first, cards.indexOf(visible.at(-1)) + 1);
        this.querySelector('[data-rail-position]').textContent = first + '–' + last + ' / ' + cards.length;
        this.querySelector('progress').value = cards.length ? last / cards.length : 1;
      };
      const move = direction => {
        const card = this.cards.find(card => !card.hidden);
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const count = Math.max(1, Math.floor((this.rail.clientWidth + gap) / step));
        this.rail.scrollBy({ left: direction * (this.dir === 'rtl' ? -1 : 1) * step * count,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragged = false;
      let suppressClick = false;
      this.cards.forEach(card => {
        card.draggable = false;
        card.querySelectorAll('img').forEach(image => { image.draggable = false; });
      });
      this.rail.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        suppressClick = false;
        dragStartX = event.clientX;
        dragStartScroll = this.rail.scrollLeft;
        dragged = false;
      }, options);
      this.rail.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse' || (event.buttons & 1) !== 1) return;
        const distance = event.clientX - dragStartX;
        if (!dragged && Math.abs(distance) < 5) return;
        if (!dragged) {
          dragged = true;
          this.rail.setPointerCapture(event.pointerId);
          this.rail.classList.add('is-dragging');
        }
        this.rail.scrollLeft = dragStartScroll - distance;
        event.preventDefault();
      }, options);
      const finishDrag = event => {
        if (event.pointerType !== 'mouse') return;
        suppressClick = dragged;
        dragged = false;
        this.rail.classList.remove('is-dragging');
        if (this.rail.hasPointerCapture(event.pointerId)) this.rail.releasePointerCapture(event.pointerId);
        if (suppressClick) setTimeout(() => { suppressClick = false; }, 0);
        update();
      };
      this.rail.addEventListener('pointerup', finishDrag, options);
      this.rail.addEventListener('pointercancel', finishDrag, options);
      this.rail.addEventListener('click', event => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, { ...options, capture: true });
      this.filters.forEach(button => button.addEventListener('click', () => {
        const group = button.dataset.categoryFilter;
        this.filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        this.cards.forEach(card => { card.hidden = group !== 'all' && card.dataset.categoryGroup !== group; });
        this.rail.scrollTo({ left: 0, behavior: 'instant' });
        update();
      }, options));
      this.querySelectorAll('.dsp-category-grid__controls,.dsp-category-grid__filters,.dsp-category-grid__footer').forEach(element => { element.hidden = false; });
      this.rail.addEventListener('scroll', update, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.rail);
      update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
